import type { RefObject } from 'react';
import { revealRectangle } from '../../../util/animation/reveal/reveal';
import { findTransitionController } from '../../../util/core-transition-component';

interface PageHeaderRefs {
  titleRef: RefObject<HTMLHeadingElement | null>;
  categoryRef: RefObject<HTMLHeadingElement | null>;
  descriptionRef: RefObject<HTMLElement | null>;
  mediaWrapperRef?: RefObject<HTMLDivElement | null>;
  mediaInnerHolderRef?: RefObject<HTMLDivElement | null>;
}

export function setupTransitionInTimeline(
  timeline: gsap.core.Timeline,
  { titleRef, descriptionRef, categoryRef, mediaWrapperRef, mediaInnerHolderRef }: PageHeaderRefs,
): void {
  const clientTitleController = findTransitionController(categoryRef);
  const titleController = findTransitionController(titleRef);
  const descriptionTitleController = findTransitionController(descriptionRef);

  if (mediaInnerHolderRef?.current) {
    timeline.fromTo(
      mediaInnerHolderRef.current,
      { scale: 1.2 },
      {
        scale: 1,
        duration: 0.8,
        ease: 'Power3.easeInOut',
        clearProps: 'scale',
      },
      0,
    );
  }

  if (mediaWrapperRef?.current) {
    timeline.add(revealRectangle(mediaWrapperRef.current), 0);
  }

  timeline.addLabel('startText', '>-0.4');
  timeline.add(clientTitleController?.getTimeline('in') as gsap.core.Timeline, 'startText');
  timeline.add(titleController?.getTimeline('in') as gsap.core.Timeline, 'startText+=0.1');
  timeline.add(descriptionTitleController?.getTimeline('in') as gsap.core.Timeline, '<0.2');
}
